// extracted by mini-css-extract-plugin
export default {"productGallery":"mJ-z","infoAboveGallery":"nJ-z","inQuickShop":"oJ-z"};